/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Link, NavLink, Route, Routes, useParams } from "react-router-dom"
import { Table } from 'antd'
import { FiFolderPlus } from "react-icons/fi"
import { useState } from "react"
import { IoIosArrowDown, IoIosArrowForward, IoIosMore } from "react-icons/io"
import classNames from "classnames"
import { FaRegFile, FaRegFolder } from "react-icons/fa"
import ApiWorkspace from "./ApiWorkspace"
import TableWorkspace from "./TableWorkspace"
import QueryWorkspace from "./QueryWorkspace"
import DashboardWorkspace from "./DashboardWorkspace"
import RecentWorkspace from "./RecentWorkspace"

const testData: any = [
  {
    name: 'My APIs',
    id: '1',
    key: '1',
    type: 'apis',
    children: [
      {
        name: 'My API 1',
        id: '2',
        key: '2',
        type: 'api',
      },
      {
        name: 'My API 2',
        id: '3',
        key: '3',
        type: 'api',
      },
      {
        name: 'My API 3',
        id: '4',
        key: '4',
        type: 'api',
      },
    ]
  },
  {
    name: 'My APIsssss2',
    id: '5',
    key: '5',
    type: 'apis',
    children: [
      {
        name: 'My API 11',
        id: '6',
        key: '6',
        type: 'api',
      },
      {
        name: 'My API 21',
        id: '7',
        key: '7',
        type: 'api',
      },
      {
        name: 'My API 3',
        id: '8',
        key: '8',
        type: 'api',
      },
    ]
  }
]


export const Tabs = () => {
  const getClassNames = ({ isActive }: any) => {
    return classNames(
      'text-xl tab pb-3 h-auto mb-[-2px]',
      {
        'tab-active font-semibold border-[#fff] border-b-2': isActive,
      }
    );
  }
  // {/* Tabs - API, Query, Table, Dashboard, My Fav */}
  return <div role="tablist" className="tabs gap-8">
    <NavLink to={`/v2/workspace/apis`} role="tab"
      className={getClassNames}
    >API</NavLink>
    <NavLink to={`/v2/workspace/tables`} role="tab" className={getClassNames}>Table</NavLink>
    <NavLink to={`/v2/workspace/queries`} role="tab" className={getClassNames}>Query</NavLink>
    <NavLink to={`/v2/workspace/dashboards`} role="tab" className={getClassNames}>Dashboard</NavLink>
    <NavLink to={`/v2/workspace/recents`} role="tab" className={getClassNames}>Recents</NavLink>
  </div>
}
const Workspace = () => {

  const [activeTab, setActiveTab] = useState('apis')
  const params = useParams();

  return <div
    className=" py-10"
  >
    <div className="px-16 flex justify-between border-b-2 mb-8">
      <Tabs />
    </div>


    <div className="px-16">
      <Routes>
        <Route path="/apis" element={<div>
          <ApiWorkspace />
        </div>} />
        <Route path="/tables" element={<div>
          <TableWorkspace />
        </div>} />
        <Route path="/queries" element={<div>
          <QueryWorkspace />
        </div>} />
        <Route path="/dashboards" element={<div><DashboardWorkspace /></div>} />
        <Route path="/recents" element={<div><RecentWorkspace /></div>} />
      </Routes>
    </div>


  </div>
}

export default Workspace